"use client";
import { motion } from "framer-motion";
import Image from "next/image";
import React, { Dispatch, SetStateAction, useEffect } from "react";
import { hexToRgba } from "../../lib/hexToRgba";

interface IMultiSelectProp {
  options: any;
  selected: string[];
  setSelected: Dispatch<SetStateAction<string[]>>;
  theme: string[];
  data: Record<string, string>;
  setData: Dispatch<SetStateAction<Record<string, string>>>;
  dataKey: string;
}

const Multiselect = ({
  options,
  selected,
  setSelected,
  theme,
  data,
  setData,
  dataKey,
}: IMultiSelectProp) => {
  const handleClick = (val: string) => {
    if (val === "None") {
      setData((p) => {
        localStorage.setItem(
          "bioFormData",
          JSON.stringify({ ...p, [dataKey]: "None" })
        );
        return { ...p, [dataKey]: "None" };
      });
    } else {
      setData((p) => {
        const selectedVals = p[dataKey]?.split(",");
        if (selectedVals?.includes(val)) {
          const filteredSelected = selectedVals?.filter(
            (selected) => selected !== val
          );
          let filtered = filteredSelected?.join(",") || "";
          localStorage.setItem(
            "bioFormData",
            JSON.stringify({ ...p, [dataKey]: filtered })
          );
          return { ...p, [dataKey]: filtered };
        }
        if (!selectedVals?.includes(dataKey)) {
          if (p[dataKey]) {
            localStorage.setItem(
              "bioFormData",
              JSON.stringify({ ...p, [dataKey]: p[dataKey] + "," + val })
            );
            return { ...p, [dataKey]: p[dataKey] + "," + val };
          } else {
            localStorage.setItem(
              "bioFormData",
              JSON.stringify({ ...p, [dataKey]: val })
            );
            return { ...p, [dataKey]: val };
          }
        } else {
          localStorage.setItem(
            "bioFormData",
            JSON.stringify({ ...p, [dataKey]: val })
          );
          return { ...p, [dataKey]: val };
        }
      });
    }

    setSelected((p) => {
      let newData;
      if (val === "None") {
        return [val];
      } else {
        if (selected?.includes(val)) {
          newData = selected?.filter((el) => el !== val);
          return newData;
        } else {
          return [...p, val];
        }
      }
    });
  };

  useEffect(() => {
    if (selected.includes("None") && selected?.length > 1) {
      setSelected((p) => p.filter((el) => el != "None"));
      setData((p) => {
        const filteredSelected = p[dataKey]
          ?.split(",")
          ?.filter((el) => el !== "None")
          ?.join(",");
        return { ...p, [dataKey]: filteredSelected };
      });
    }
  }, [selected, setSelected, setData, dataKey]);

  return (
    <div className="flex flex-col gap-4 w-full">
      {options?.map((option, idx) => {
        const isSelected = selected.includes(option.option);
        return (
          <motion.div
            onClick={() => handleClick(option.option)}
            key={option.option}
            style={{
              backgroundColor: isSelected ? theme[0] : hexToRgba(theme[0], 0.2),
              fontWeight: isSelected ? "bold" : "normal",
              color: isSelected ? "#222" : "black",
            }}
            className="flex gap-4  justify-between cursor-pointer p-2 border-black rounded-lg text-black items-center "
          >
            <div className="flex items-center gap-4">{option.option}</div>
            <Image
              style={{}}
              src={
                isSelected
                  ? "https://storage.googleapis.com/bonatra-assets/BonatraApplicationAssets/Select.svg"
                  : "https://storage.googleapis.com/bonatra-assets/BonatraApplicationAssets/Add.svg"
              }
              height={24}
              width={24}
              alt="icon"
            ></Image>
          </motion.div>
        );
      })}
    </div>
  );
};

export default Multiselect;
